import config from '../config.json';

export function primaryRestGateway() {
	return config[process.env.REACT_APP_ENV].primaryRestGateway;
}
